// extracted by mini-css-extract-plugin
export var acitonButtons = "_h6-0";
export var additionalIcon = "_h6-f";
export var block = "_h6-1";
export var blockContent = "_h6-7";
export var blockDescription = "_h6-8";
export var blockIcon = "_h6-9";
export var blockTitle = "_h6-6";
export var border = "_h6-a";
export var center = "_h6-l";
export var edge = "_h6-b";
export var edgeLabel = "_h6-c";
export var edgePath = "_h6-d";
export var error = "_h6-e";
export var flowchart = "_h6-g";
export var flowchartContent = "_h6-h";
export var highlighted = "_h6-3";
export var hover = "_h6-4";
export var icon = "_h6-i";
export var left = "_h6-m";
export var navButton = "_h6-j";
export var navButtons = "_h6-k";
export var right = "_h6-n";
export var selected = "_h6-2";
export var small = "_h6-5";